import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "./ReviewRating.css";
import Loader from "../utils/loader";
import AdminServices from "../services/adminServices";
import CommentCard from "../components/Cards/AdminCommentsCard";
import _ from 'lodash';
import {
  Container,
  Paper,
  Typography,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  Stack,
  IconButton,
  InputAdornment
} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export class ReviewRating extends Component {
  state = {
    loading: true,
    dashlink: "./admindashboard",
    comments: [],
    filterComments: [],
    DocumentList: [],
    DocumentListType: [],
    ratings: "all",
    search: "",
  };

  async componentDidMount() {
    await this.getallComments();
  }

  getallComments = async () => {
    let { Document_Comment, Blog_Comments, status } = await AdminServices.getAllComments();
    let data = _.concat(Document_Comment, Blog_Comments);

    if (status === 200) {
      this.getDocumentList(data);
      this.setState({
        comments: data,
        filterComments: data,
        loading: false,
      });
    } else {
      this.setState({ loading: false });
      toast.warn("No Comments Found !");
    }
  };

  getDocumentList = async (data) => {
    let DocumentList = [];
    let DocumentListType = [];
    let belongs = 0;

    for (let i = 0; i < data.length; i++) {
      if (data[i].documentID) {
        if (DocumentList.includes(data[i].documentID.documentName)) {
          continue;
        } else {
          DocumentList.push(data[i].documentID.documentName);
          DocumentListType.push((data[i].documentType).toUpperCase());
        }
      } else {
        belongs = 1;
      }
    }

    if (belongs === 1) {
      DocumentList.push("Additional Reviews");
      DocumentListType.push("GENERAL");
    }

    this.setState({ DocumentList: DocumentList, DocumentListType: DocumentListType });
  };

  removecomment_ = async (id, belongsTo, rating, replies, documentType) => {
    let data = {
      document_id: id,
      comment_id: belongsTo,
      commentRating: rating,
      commentReplies: replies,
      documentType: documentType,
    };
    
    this.setState({ loading: true });
    const res = await AdminServices.removecomment(data);
    if (res.status === 200) {
      toast.success(res.message);
      this.getallComments();
    } else {
      toast.error("Oops something went wrong..!");
      this.setState({ loading: false });
    }
  };

  handleSearch = (e) => {
    let comments = this.state.comments;
    this.setState({ search: e.target.value });

    if (e.target.value === "") {
      if (this.state.ratings == "all") {
        this.getDocumentList(this.state.comments);
        this.setState({
          filterComments: this.state.comments,
        });
      } else {
        let result = comments.filter((member) => {
          if (member.postedBy && member.rating == this.state.ratings) {
            return member;
          }
        });
        this.getDocumentList(result);
        this.setState({ filterComments: result });
      }
    } else {
      let value = e.target.value;

      let result1 = [];
      result1 = comments.filter((member) => {
        if (this.state.ratings != "all") {
          if (
            member.postedBy &&
            member.rating == this.state.ratings &&
            member.postedBy.username
              .toLowerCase()
              .indexOf(value.toLowerCase()) > -1
          ) {
            return member;
          }
        } else {
          if (
            member.postedBy &&
            member.postedBy.username
              .toLowerCase()
              .indexOf(value.toLowerCase()) > -1
          ) {
            return member;
          }
        }
      });

      this.getDocumentList(result1);
      this.setState({ filterComments: result1 });
    }
  };

  handleRatingFilter = (e) => {
    let selectedRating = e.target ? e.target.value : e;
    this.setState({ ratings: selectedRating });
    let comments = this.state.comments;
    let search = this.state.search;

    if (selectedRating === "all") {
      if (search === "") {
        this.getDocumentList(comments);
        this.setState({ filterComments: this.state.comments });
      } else {
        let result = comments.filter((member) => {
          if (
            member.postedBy &&
            member.postedBy.username
              .toLowerCase()
              .indexOf(search.toLowerCase()) > -1
          ) {
            return member;
        }
        });
        this.getDocumentList(result);
        this.setState({ filterComments: result });
      }
    } else {
      if (search === "") {
        let filteredComments = comments.filter(
          (comment) => comment.rating == selectedRating
        );
        this.getDocumentList(filteredComments);
        this.setState({ filterComments: filteredComments });
      } else {
        let result1 = comments.filter((member) => {
          if (
            member.postedBy &&
            member.rating == selectedRating &&
            member.postedBy.username
              .toLowerCase()
              .indexOf(search.toLowerCase()) > -1
          ) {
            return member;
          }
        });
        this.getDocumentList(result1);
        this.setState({ filterComments: result1 });
      }
    }
  };

  refreshContent = () => {
    this.getallComments();
  };

  renderStarRating = (rating) => {
    return (
      <Stack direction="row" spacing={0.5}>
        {[1, 2, 3, 4, 5].map((star) => (
          <StarIcon
            key={star}
            sx={{
              color: star <= rating ? "#FFD700" : "#e0e0e0",
              fontSize: "1.2rem"
            }}
          />
        ))}
      </Stack>
    );
  };

  getFilterLabel = (value) => {
    if (value === "all") {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FilterListIcon sx={{ mr: 1, fontSize: 18, color: '#1976d2' }} />
          <Typography variant="body2">Filter by Rating</Typography>
        </Box>
      );
    }
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {this.renderStarRating(parseInt(value))}
        <Typography variant="body2" sx={{ ml: 1 }}>
          {value} Star{value > 1 ? 's' : ''}
        </Typography>
      </Box>
    );
  };

  getTypeColor = (type) => {
    switch(type) {
      case 'DOCUMENT':
        return '#1976d2';
      case 'BLOG':
        return '#2e7d32';
      default:
        return '#9c27b0';
    }
  };

  render() {
    const { dashlink, filterComments, DocumentList, DocumentListType, ratings, search } = this.state;
    const totalReviews = filterComments.length;

    return (
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Loader loading={this.state.loading} />
        <ToastContainer />
        
        <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
          <Grid container spacing={3} alignItems="center" justifyContent="space-between">
            <Grid xs={12} md={4}>
              <Typography variant="h5" sx={{ fontWeight: 600, color: '#1976d2' }}>
                Manage Reviews
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {totalReviews} {totalReviews === 1 ? 'review' : 'reviews'}
              </Typography>
            </Grid>
            
            <Grid xs={12} md={8}>
              <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
                <Grid xs={12} sm={4} md={3}>
                  <TextField
                    fullWidth
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => this.handleSearch(e)}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: 'action.active' }} />
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: 2,
                        backgroundColor: 'white',
                        '&:hover': {
                          borderColor: '#1976d2',
                        }
                      }
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      }
                    }}
                  />
                </Grid>
                
                <Grid xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <Select
                      value={ratings}
                      onChange={this.handleRatingFilter}
                      displayEmpty
                      IconComponent={KeyboardArrowDownIcon}
                      renderValue={(value) => this.getFilterLabel(value)}
                      sx={{
                        borderRadius: 2,
                        backgroundColor: 'white',
                        '& .MuiSelect-select': {
                          padding: '8.5px 14px',
                          display: 'flex',
                          alignItems: 'center',
                        },
                        '&:hover': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused': {
                          borderColor: '#1976d2',
                        }
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: 2,
                            mt: 1,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                          }
                        }
                      }}
                    >
                      <MenuItem value="all">
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <StarIcon sx={{ mr: 2, color: '#FFD700' }} />
                          <Box>
                            <Typography variant="body2" fontWeight={500}>All Ratings</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Show all reviews
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                      
                      <Box sx={{ px: 2, py: 1 }}>
                        <Typography variant="caption" color="text.secondary" fontWeight={500}>
                          FILTER BY STAR RATING
                        </Typography>
                      </Box>
                      
                      {[5, 4, 3, 2, 1].map((rating) => (
                        <MenuItem key={rating} value={rating.toString()} sx={{ py: 1.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              {this.renderStarRating(rating)}
                              <Typography variant="body2" sx={{ ml: 2 }}>
                                {rating} Star{rating > 1 ? 's' : ''}
                              </Typography>
                            </Box>
                            <Chip 
                              label={this.state.comments.filter(c => c.rating === rating).length}
                              size="small"
                              sx={{ 
                                backgroundColor: '#e3f2fd',
                                color: '#1976d2',
                                fontWeight: 500,
                              }}
                            />
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid xs={12} sm={2} md={1}>
                  <IconButton
                    onClick={this.refreshContent}
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#1565c0',
                      },
                      borderRadius: 2,
                      height: '40px',
                      width: '40px'
                    }}
                    title="Refresh Reviews"
                  >
                    <RefreshIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        {DocumentList.length > 0 ? (
          <Box>
            {DocumentList.map((document, index) => {
              const documentReviewsCount = filterComments.filter(comment => 
                document === "Additional Reviews" 
                  ? !comment.documentID 
                  : (comment.documentID && comment.documentID.documentName === document)
              ).length;

              if (documentReviewsCount === 0) return null;

              return (
                <Accordion
                  key={index}
                  sx={{
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    '&:before': { display: 'none' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      backgroundColor: '#f5f7ff',
                      borderRadius: '8px 8px 0 0',
                      borderBottom: '1px solid #e0e0e0',
                      '&.Mui-expanded': {
                        minHeight: 48,
                        borderRadius: '8px 8px 0 0',
                      },
                      minHeight: 56,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Chip
                        label={
                          <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            minWidth: 100,
                            px: 2,
                          }}>
                            <Typography variant="body2" fontWeight={500}>
                              {DocumentListType[index] || "GENERAL"}
                            </Typography>
                          </Box>
                        }
                        size="medium"
                        sx={{
                          mr: 2,
                          backgroundColor: this.getTypeColor(DocumentListType[index]),
                          color: 'white',
                          fontWeight: 500,
                          height: 32,
                          '& .MuiChip-label': {
                            padding: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                          }
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          color: '#333',
                          flexGrow: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          pr: 2
                        }}
                      >
                        {document}
                      </Typography>
                      <Chip
                        label={`${documentReviewsCount} ${documentReviewsCount === 1 ? 'review' : 'reviews'}`}
                        size="small"
                        variant="outlined"
                        sx={{ 
                          borderColor: '#1976d2', 
                          color: '#1976d2',
                          minWidth: 80,
                          justifyContent: 'center',
                          height: 32,
                        }}
                      />
                    </Box>
                  </AccordionSummary>
                  
                  <AccordionDetails sx={{ p: 3, backgroundColor: 'white' }}>
                    <Grid container spacing={3}>
                      {filterComments.map((comment, commentIndex) => (
                        <React.Fragment key={commentIndex}>
                          {document === "Additional Reviews" ? (
                            !comment.documentID && (
                              <Grid xs={12}>
                                <Card 
                                  sx={{ 
                                    mb: 2, 
                                    borderRadius: 2,
                                    border: '1px solid #e0e0e0',
                                    boxShadow: 'none'
                                  }}
                                >
                                  <CardContent sx={{ p: 3 }}>
                                    <CommentCard
                                      data={comment}
                                      delete={this.removecomment_}
                                      adminPost={this.refreshContent}
                                    />
                                  </CardContent>
                                </Card>
                              </Grid>
                            )
                          ) : (
                            comment.documentID &&
                            comment.documentID.documentName === document && (
                              <Grid xs={12}>
                                <Card 
                                  sx={{ 
                                    mb: 2, 
                                    borderRadius: 2,
                                    border: '1px solid #e0e0e0',
                                    boxShadow: 'none'
                                  }}
                                >
                                  <CardContent sx={{ p: 3 }}>
                                    <CommentCard
                                      data={comment}
                                      delete={this.removecomment_}
                                      adminPost={this.refreshContent}
                                    />
                                  </CardContent>
                                </Card>
                              </Grid>
                            )
                          )}
                        </React.Fragment>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        ) : (
          <Paper 
            elevation={0}
            sx={{ 
              p: 8, 
              textAlign: 'center', 
              borderRadius: 2,
              backgroundColor: '#f8f9fa'
            }}
          >
            <Box sx={{ color: '#9e9e9e', mb: 2 }}>
              <StarBorderIcon sx={{ fontSize: 60, opacity: 0.5 }} />
            </Box>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No Reviews Found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              There are no reviews to display at the moment.
            </Typography>
          </Paper>
        )}
      </Container>
    );
  }
}

export default ReviewRating;